import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useEffect, useState } from 'react';
import { View, Text, Dimensions, Pressable, Image, Platform } from 'react-native'; // import { Image } from '../../Image/rn';

import OrderArrowRight from '../../../assets/images/rn/OrderArrowRight';
import { useLocale } from '../../LocaleProvider/rn';
import { ITEMS_TEXT, ITEM_TEXT, BUYER_ORDER_LIST_TITLE_TEXT } from '../../../utils/constants';
import { ModeType } from '../../Webform/rn';
import { Popup } from '../../Popup/rn';
import { Button } from '../../Button/rn';
import { ProductListTabs } from '../../ProductList/rn/ProductListTabs';
import { useTracking } from '../../../hooks/rn/useTracking';
import Styles from './styles';
import Skeleton from './skeleton';
export var WebFormOrder = function WebFormOrder(props) {
  var getData = props.getData,
    mode = props.mode,
    orderListProps = props.orderListProps,
    onChange = props.onChange,
    value = props.value,
    orderStyle = props.orderStyle,
    label = props.label,
    _props$trackingData = props.trackingData,
    trackingData = _props$trackingData === void 0 ? {} : _props$trackingData;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    orderListVisible = _useState2[0],
    setOrderListVisible = _useState2[1];
  var _useLocale = useLocale(),
    trans = _useLocale.trans; // const [errMsg, setErrMsg] = React.useState<string | undefined>(undefined);

  var _useTracking = useTracking({
      trackingData: _objectSpread(_objectSpread({}, trackingData), {}, {
        trackingdataBasic: _objectSpread(_objectSpread({}, (trackingData === null || trackingData === void 0 ? void 0 : trackingData.trackingdataBasic) || {}), {}, {
          field_name: label
        })
      })
    }),
    tracker = _useTracking.tracker,
    trackingClick = _useTracking.trackingClick; // const formContext = useContext(FormContext) as any;
  // useEffect(() => {
  //   if (formContext?.validateStatus === ValidateStatusType.Validating) {
  //     const res = handleValidate(props.value as string);
  //     formContext?.handleFormItemValidate?.({
  //       [props.name]: res ? res : ValidateStatusType.Success,
  //     });
  //   }
  // }, [props.value, formContext?.validateStatus]);
  // const handleValidate = (value: string) => {
  //   if (props.required) {
  //     if (!value) {
  //       setErrMsg('The Field is required');
  //       return 'The Field is required';
  //     }
  //   }
  //   setErrMsg(undefined);
  // };
  // useEffect(() => {
  //   // TODO: 在 RN 的 tracker 写好之前，先手动触发 impression 上报
  //   if (Platform.OS === 'web') {
  //     props.trackingData &&
  //       dataMaintainer.tracker?.dispatchTrack({
  //         operation: TRACKING_OPERATION.IMPRESSION,
  //         section: props.trackingData.trackingsection,
  //         target: TRACKING_TARGET.webform,
  //         data: {
  //           viewed_objects: [{ ...(props.trackingData.trackingdataBasic || {}) }],
  //         },
  //       });
  //   }
  // }, []);

  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    orderData = _useState4[0],
    setOrderData = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isInit = _useState6[0],
    setIsInit = _useState6[1];
  var _ref = orderData || {},
    itemsText = _ref.itemsText,
    itemText = _ref.itemText,
    itemCount = _ref.itemCount,
    totalPrice = _ref.totalPrice,
    orderStatusText = _ref.orderStatusText,
    title = _ref.title,
    specification = _ref.specification,
    _ref$image = _ref.image,
    image = _ref$image === void 0 ? '' : _ref$image;
  var isPreview = ModeType.View === mode;
  useEffect(function () {
    if (getData && value) {
      getData(value).then(function (result) {
        if (result) {
          setOrderData(result);
        }
      }).finally(function () {
        setIsInit(true);
      });
    } else {
      setIsInit(true);
    }
  }, [value]);
  var handleOrderList = function handleOrderList() {
    Platform.OS === 'web' && trackingClick && tracker.click(trackingClick);
    if (isPreview) {
      return;
    }
    setOrderListVisible(true);
  };
  {
    /* 当没有 order data 又 处于 preview 状态时 显示为 null */
  }
  var notOrderDataRender = function notOrderDataRender() {
    return isPreview ? null : /*#__PURE__*/React.createElement(Pressable, {
      style: Styles['select-order']
    }, /*#__PURE__*/React.createElement(View, {
      style: Styles['select-order-label-wrapper']
    }, /*#__PURE__*/React.createElement(Text, {
      style: Styles['select-order-label']
    }, label)), /*#__PURE__*/React.createElement(Button, {
      styles: {
        containerStyle: {
          paddingBottom: 9,
          paddingTop: 8,
          marginLeft: 0,
          marginRight: 0
        }
      },
      type: "primary-outlined",
      onClick: handleOrderList
    }, /*#__PURE__*/React.createElement(Text, {
      style: Styles['select-order-button-text']
    }, "Select Order")));
  };
  return /*#__PURE__*/React.createElement(View, {
    style: Styles.container,
    key: value
  }, isInit ? orderData ? /*#__PURE__*/React.createElement(Pressable, {
    style: [Styles.order, orderStyle],
    onPress: handleOrderList
  }, /*#__PURE__*/React.createElement(Image, {
    source: {
      uri: image
    } // src={image}
    // styles={{ imageStyle: Styles['order-img'] }}
    ,

    style: Styles['order-img'],
    width: Styles['order-img'].width,
    height: Styles['order-img'].height
  }), /*#__PURE__*/React.createElement(View, {
    style: Styles['order-center']
  }, /*#__PURE__*/React.createElement(View, {
    style: Styles['order-name']
  }, /*#__PURE__*/React.createElement(Text, {
    numberOfLines: 1,
    ellipsizeMode: "tail"
  }, title)), /*#__PURE__*/React.createElement(View, {
    style: Styles['order-center-center']
  }, /*#__PURE__*/React.createElement(Text, {
    numberOfLines: 1,
    ellipsizeMode: "tail",
    style: Styles['order-count']
  }, itemCount, " ", Number(itemCount) > 1 ? itemsText || trans(ITEMS_TEXT) : itemText || trans(ITEM_TEXT)), /*#__PURE__*/React.createElement(Text, {
    numberOfLines: 1,
    ellipsizeMode: "tail",
    style: Styles['order-price']
  }, specification, " ", totalPrice)), /*#__PURE__*/React.createElement(View, {
    style: Styles['order-status']
  }, /*#__PURE__*/React.createElement(Text, {
    numberOfLines: 1,
    ellipsizeMode: "tail",
    style: Styles['order-status-text']
  }, orderStatusText))), isPreview ? null : /*#__PURE__*/React.createElement(OrderArrowRight, {
    style: Styles['order-arrow']
  })) : notOrderDataRender() : /*#__PURE__*/React.createElement(Skeleton, null), orderListProps ? /*#__PURE__*/React.createElement(Popup, {
    title: trans(BUYER_ORDER_LIST_TITLE_TEXT),
    showCloseIcon: true,
    active: orderListVisible,
    onClose: function onClose() {
      setOrderListVisible(false);
      Promise.resolve().then(function () {
        var _props$closeForm;
        (_props$closeForm = props.closeForm) === null || _props$closeForm === void 0 ? void 0 : _props$closeForm.call(props);
      });
    },
    titleStyle: {
      textAlign: 'center'
    },
    contentContainerStyle: {
      height: Dimensions.get('window').height * 0.8
    },
    contentStyle: {
      padding: 0,
      paddingBottom: 20,
      backgroundColor: '#f5f5f5'
    },
    contentScrollable: false,
    delayBeforeContentShow: 300,
    showPrevIcon: true,
    onPrev: function onPrev() {
      setOrderListVisible(false);
    }
  }, /*#__PURE__*/React.createElement(ProductListTabs, _extends({}, orderListProps, {
    onButtonClick: function onButtonClick(params) {
      if (orderListProps !== null && orderListProps !== void 0 && orderListProps.onButtonClick) {
        orderListProps.onButtonClick(params);
      }
      if (onChange) {
        var _params$data;
        onChange(params === null || params === void 0 ? void 0 : (_params$data = params.data) === null || _params$data === void 0 ? void 0 : _params$data.orderSn);
      }
      setOrderListVisible(false);
    }
  }))) : null);
};